module.exports = __webpack_public_path__ + "img/google-cloud-blog-01.f969ab36.webp";